var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "header" }, [
    _c("nav", { staticClass: "header__nav", class: _vm.headerNavClass }, [
      _c("div", { staticClass: "header__nav-header" }, [
        _c("div", { staticClass: "header__collapse" }, [
          _c(
            "button",
            {
              on: {
                click: function($event) {
                  return _vm.navToggle()
                }
              }
            },
            [
              _c("span", { staticClass: "material-icons" }, [
                _vm._v(_vm._s(_vm.burgerIcon))
              ])
            ]
          )
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "header__logo" },
          [
            _c("router-link", { attrs: { to: "/filialfinder/home" } }, [
              _c("img", {
                class: { additionalMarginToCenterLogo: _vm.isNotAppView },
                attrs: {
                  src: "images/Cash_Pool_Logo.svg",
                  height: "40",
                  width: "40"
                }
              })
            ])
          ],
          1
        ),
        _vm._v(" "),
        _vm.showSearchBarToggle
          ? _c(
              "button",
              {
                on: {
                  click: function($event) {
                    return _vm.toggleSearchBar()
                  }
                }
              },
              [
                _c("i", { staticClass: "material-icons" }, [
                  _vm._v(_vm._s(_vm.isSearchBarVisible ? "close" : "search"))
                ])
              ]
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _c(
        "ul",
        { staticClass: "header__nav-list" },
        _vm._l(_vm.navItems, function(navItem, i) {
          return _c(
            "li",
            {
              key: i,
              on: {
                click: function($event) {
                  return _vm.navToggle()
                }
              }
            },
            [
              _c(
                "router-link",
                { attrs: { to: navItem.path, "data-title": navItem.title } },
                [
                  _c("i", { staticClass: "material-icons" }, [
                    _vm._v(_vm._s(navItem.icon))
                  ]),
                  _vm._v(" "),
                  _c("span", [_vm._v(_vm._s(navItem.title))])
                ]
              )
            ],
            1
          )
        }),
        0
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }